import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=43921608&scoped=true&"
import script from "./Footer.vue?vue&type=script&lang=js&"
export * from "./Footer.vue?vue&type=script&lang=js&"
import style0 from "./Footer.vue?vue&type=style&index=0&id=43921608&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43921608",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CartAddedToCartModal: require('/opt/build/repo/components/Cart/AddedToCartModal.vue').default,UISearch: require('/opt/build/repo/components/UI/Search.vue').default})
